import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';

// Aufnahmeantrag in der Trainer-App
const PFLICHT_TRAININGS = 2;

// Kennzeichen in Listen (Mitglieder, Anwesenheit)
export function TrainerAntragBadge({ s }) {
  if (s.aufnahmeantrag_status === 'fehlt' && s.aufnahmeantrag_ueberfaellig) {
    return <span style={{ display: 'inline-block', background: '#c62828', color: '#fff', borderRadius: 10, padding: '1px 8px', fontSize: '0.7rem', fontWeight: 700 }}>⚠ Aufnahmeantrag fehlt</span>;
  }
  if (s.aufnahmeantrag_status === 'fehlt') {
    return <span style={{ display: 'inline-block', background: '#fff3e0', color: '#e65100', borderRadius: 10, padding: '1px 8px', fontSize: '0.7rem', fontWeight: 700 }}>Antrag fehlt · {s.aufnahmeantrag_trainings ?? 0}/{PFLICHT_TRAININGS} Trainings</span>;
  }
  return null;
}

// Deutlicher Hinweis oben auf Gruppen- und Trainingsseite
export function TrainerAntragWarnung({ kinder }) {
  const navigate = useNavigate();
  const ueberfaellig = (kinder || []).filter(k => k.aufnahmeantrag_status === 'fehlt' && k.aufnahmeantrag_ueberfaellig);
  if (!ueberfaellig.length) return null;
  return (
    <div role="alert" style={{
      background: '#c62828', color: '#fff', borderRadius: 12, padding: '0.875rem 1rem',
      marginBottom: '0.875rem', boxShadow: '0 2px 8px rgba(198,40,40,0.35)',
    }}>
      <div style={{ fontWeight: 800, fontSize: '1rem', marginBottom: '0.3rem' }}>
        ⚠ Aufnahmeantrag überfällig ({ueberfaellig.length})
      </div>
      <div style={{ fontSize: '0.85rem', marginBottom: '0.5rem', lineHeight: 1.45 }}>
        Diese Kinder waren schon bei {PFLICHT_TRAININGS} oder mehr Trainings ohne abgegebenen Aufnahmeantrag.
        Bitte die Eltern heute ansprechen und den Antrag einsammeln.
      </div>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.4rem' }}>
        {ueberfaellig.map(k => (
          <button key={k.schwimmer_id} onClick={() => navigate(`/trainer/schwimmer/${k.schwimmer_id}`)}
            style={{ background: '#fff', color: '#c62828', border: 'none', borderRadius: 20, padding: '0.3rem 0.75rem', fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer' }}>
            {k.vorname} {k.nachname} ›
          </button>
        ))}
      </div>
    </div>
  );
}

// Karte auf der Kinderseite: Papier-Antrag entgegennehmen
export function TrainerAntragKarte({ schwimmer, onGeaendert }) {
  const [url, setUrl] = useState('');
  const [arbeitet, setArbeitet] = useState(false);
  const [fehler, setFehler] = useState('');

  useEffect(() => {
    api.get('/api/trainer/aufnahmeantrag/link').then(r => setUrl(r.data.url || '')).catch(() => {});
  }, []);

  const status = schwimmer.aufnahmeantrag_status;
  if (!status || status === 'eingegangen') return null;

  const setzen = async (abgegeben) => {
    setArbeitet(true); setFehler('');
    try {
      const r = await api.post(`/api/trainer/schwimmer/${schwimmer.id}/aufnahmeantrag`, { abgegeben });
      onGeaendert(r.data);
    } catch (err) {
      setFehler(err.response?.data?.error || 'Konnte nicht gespeichert werden');
    } finally { setArbeitet(false); }
  };

  const ueberfaellig = status === 'fehlt' && schwimmer.aufnahmeantrag_ueberfaellig;

  return (
    <div style={{
      background: status === 'beim_trainer' ? '#e3f2fd' : ueberfaellig ? '#c62828' : '#fff3e0',
      color: ueberfaellig ? '#fff' : '#222',
      border: `2px solid ${status === 'beim_trainer' ? '#90caf9' : ueberfaellig ? '#c62828' : '#ffb74d'}`,
      borderRadius: 12, padding: '1rem', marginBottom: '0.875rem',
    }}>
      {status === 'beim_trainer' ? (
        <>
          <div style={{ fontWeight: 700, color: '#1565c0' }}>📄 Aufnahmeantrag entgegengenommen</div>
          <div style={{ fontSize: '0.82rem', color: '#555', margin: '0.25rem 0 0.6rem' }}>
            {schwimmer.aufnahmeantrag_trainer_name ? `Von ${schwimmer.aufnahmeantrag_trainer_name}` : 'Beim Trainer'}
            {schwimmer.aufnahmeantrag_trainer_am && ` am ${new Date(schwimmer.aufnahmeantrag_trainer_am).toLocaleDateString('de-DE')}`}.
            Bitte das Papier an den Schwimmadmin weitergeben.
          </div>
          <button onClick={() => setzen(false)} disabled={arbeitet}
            style={{ background: '#fff', border: '1px solid #90caf9', color: '#1565c0', borderRadius: 8, padding: '0.45rem 0.8rem', fontSize: '0.82rem', cursor: 'pointer' }}>
            Rückgängig
          </button>
        </>
      ) : (
        <>
          <div style={{ fontWeight: 800, fontSize: ueberfaellig ? '1.05rem' : '0.95rem' }}>
            {ueberfaellig ? '⚠ Aufnahmeantrag überfällig' : 'Aufnahmeantrag fehlt noch'}
          </div>
          <div style={{ fontSize: '0.85rem', margin: '0.25rem 0 0.75rem', lineHeight: 1.45 }}>
            Vorläufig aufgenommen · {schwimmer.aufnahmeantrag_trainings ?? 0} von {PFLICHT_TRAININGS} Trainings besucht.
            {ueberfaellig ? ' Bitte die Eltern heute ansprechen.' : ' Der Antrag muss spätestens beim 2. Training abgegeben werden.'}
          </div>
          <button onClick={() => window.confirm('Den unterschriebenen Aufnahmeantrag auf Papier entgegengenommen?') && setzen(true)} disabled={arbeitet}
            style={{ width: '100%', background: ueberfaellig ? '#fff' : '#1565c0', color: ueberfaellig ? '#c62828' : '#fff',
              border: 'none', borderRadius: 10, padding: '0.8rem', fontWeight: 700, fontSize: '0.95rem', cursor: 'pointer' }}>
            {arbeitet ? 'Speichere…' : '📄 Papier-Antrag entgegengenommen'}
          </button>
          {url && (
            <a href={url} target="_blank" rel="noopener noreferrer"
              style={{ display: 'block', marginTop: '0.6rem', fontSize: '0.8rem', color: ueberfaellig ? '#fff' : '#1565c0' }}>
              Formular (PDF) zum Ausdrucken öffnen
            </a>
          )}
        </>
      )}
      {fehler && <div style={{ marginTop: '0.5rem', fontSize: '0.8rem', fontWeight: 600 }}>{fehler}</div>}
    </div>
  );
}
